module.exports = __webpack_public_path__ + "img/serviceXCareWarranty.95e7756a.png";